import { useNavigate } from 'react-router'
import { Footer } from 'src/components/intro/Footer'
import { FooterContent } from 'src/components/intro/FooterContent'
import { Introduce } from 'src/components/intro/Introduce'
import { PriceNotice } from 'src/components/intro/PriceNotice'
import { UlContent } from 'src/components/intro/UlContent'
import * as Intro from 'src/styles/views/intro'
export const IntroPage = () => {
  const navigate = useNavigate()

  return (
    <Intro.MainWrap>
      <Intro.ContentWrap>
        <Introduce />
        <UlContent />
        <PriceNotice />
      </Intro.ContentWrap>
      <FooterContent />
      <Footer navigate={navigate} />
    </Intro.MainWrap>
  )
}
